import styled from 'styled-components';
import { fontUi } from '../../theme/typography';

export const StyledTooltip = styled.div`
  ${fontUi};
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  border-radius: ${({ theme }) => theme.cardRadius};
  padding: 16px 16px 12px;
  max-width: 320px;
  font-size: 14px;
  line-height: 1.45;
`;

export const StyledContent = styled.div`
  margin-bottom: 14px;
`;

export const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const StyledSkipGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const StyledNavGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const StyledDot = styled.span`
  color: ${({ theme }) => theme.border};
  font-size: 13px;
  line-height: 1;
  user-select: none;
`;

export const StyledTextButton = styled.button`
  ${fontUi};
  background: transparent;
  border: 0;
  padding: 0;
  color: ${({ theme }) => theme.textMuted};
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.text};
  }
`;

export const StyledPrimaryButton = styled.button`
  ${fontUi};
  background: ${({ theme }) => (theme.isDark ? 'transparent' : theme.button)};
  color: ${({ theme }) => (theme.isDark ? theme.text : theme.buttonText)};
  border: 1px solid ${({ theme }) => (theme.isDark ? theme.border : theme.button)};
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;
